<template>
  <div fluid class="w-100">
    <component :is="`style`">
      @page {
        size: A4 {{landscape && landscape !== 'null' ? 'landscape' : 'portrait'}}!important;
      }
      @media print {
        html, body {
          height: 297mm;
          margin: 0 auto;
          width: auto!important;
        }
      }
      .table_print td, .table_print th {
        font-size: {{titulo === 'Orçamentos gerados' ? '9.5px' : landscape && landscape !== 'null' ? '10px' : '11px'}}!important;
        height: 35px!important;
      }
      .v-data-table>.v-data-table__wrapper>table>thead>tr>th {
        padding: 0 8px!important;
      }
    </component>
    <v-row align="center" class="w-100">
      <v-col cols="12" sm="12">
        <div class="text-center">
          <img class="menu__open" src="@/assets/img/logo.png" alt="Logo">
        </div>
      </v-col>
      <v-col cols="12" sm="12">
        <div class="text-h1 mb-3 text-center" v-if="titulo && titulo !== 'null'">
          <b>{{titulo}}</b>
        </div>
        <div class="text-h3 mb-3 text-center" v-if="subtitulo && subtitulo !== 'null'">
          {{subtitulo}}
        </div>
      </v-col>
    </v-row>
    <div v-if="tabela && isRelatorio === false" class="w-100">
      <v-data-table
        :mobile-breakpoint="tamanhoLista"
        :headers="tabela.headers"
        :items="dados"
        disable-sort
        hide-default-footer
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        :items-per-page="-1"
        class="base_table table_print w-100 ml-0"
      >
      </v-data-table>
    </div>
    <div v-else>
      <v-row no-gutters>
        <v-col cols="12" v-for="(item, index) of dados" :key="index" class="mb-5">
          <p class="pl-1 mb-0" :class="item.uuid_orc_id ? 'mt-4' : ''">
            <span
              v-if="!item.uuid_orc_id"
              class="relatorio-link font-weight-black text-capitalize text-h3"
            >
              {{ item.cliente.cli_nome }} /
            </span>
            <span
              v-if="item.uuid_opu_id"
              class="relatorio-link font-weight-light text-caption"
            >
              Cód. da Oportunidade: {{ item.opu_id }}
            </span>
            <span
              v-if="item.pos_id"
              class="relatorio-link font-weight-light text-caption"
            >
              / Cód. da Proposta: {{ item.pos_id }}
            </span>

            <span
              v-if="item.uuid_orc_id"
              class="relatorio-link font-weight-black text-capitalize text-h3"
            >
              Cód. {{ item.cliente.cli_id }} - {{ item.cliente.cli_nome }} /
            </span>
            <span
              v-if="item.uuid_orc_id"
              class="relatorio-link font-weight-light text-caption"
            >
              Cód. do Orçamento: {{ item.orc_id }}
            </span>
          </p>
          <v-data-table
            :mobile-breakpoint="tamanhoLista"
            :headers="tabela.headers"
            :items="[item]"
            disable-sort
            hide-default-footer
            loading-text="Carregando... Por favor aguarde"
            :loading="carregando"
            :items-per-page="-1"
            class="base_table table_print w-100 ml-0"
          >
          </v-data-table>
        </v-col>
      </v-row>
    </div>
    <div v-if="tabelaExtra" class="w-100">
      <v-row class="w-100">
        <v-col cols="12" sm="12">
          <div class="text-h1 mb-3 mt-5 text-center" v-if="tabelaExtra.titulo">
            <b>{{tabelaExtra.titulo}}</b>
          </div>
        </v-col>
      </v-row>
      <v-data-table
        :mobile-breakpoint="tamanhoLista"
        :headers="tabelaExtra.headers"
        :items="tabelaExtra.dados"
        disable-sort
        hide-default-footer
        loading-text="Carregando... Por favor aguarde"
        :loading="carregando"
        :items-per-page="-1"
        class="base_table table_print w-100"
      >
      </v-data-table>
    </div>
    <div class="text mt-2 text--thin text-small text-right w-100">
      Lista exportada em: {{ moment(new Date()).format('DD/MM/YYYY, [às] HH:mm:ss') }}
    </div>
  </div>
</template>

<script>
import Api from '@API'
import moment from 'moment'
export default {
  data () {
    return {
      theme: false,
      carregando: false,
      tabela: null,
      headers: null,
      titulo: '',
      dados: [],
      url: null,
      isRelatorio: false,
      subtitulo: null,
      tamanhoLista: 0,
      landscape: false,
      tabelaExtra: null,
      statusGerais: [
        {
          text: 'Aberta',
          color: 'blue',
          value: 1
        },
        {
          text: 'Perdida',
          color: 'red',
          value: 2
        },
        {
          text: 'Fechada',
          color: 'green',
          value: 3
        }
      ],
      padroes: [
        {
          text: 'Monofásico',
          value: 1
        },
        {
          text: 'Bifásico',
          value: 2
        },
        {
          text: 'Trifásico',
          value: 3
        }
      ],
      modalidades: [
        {
          text: 'Grupo B - Convencional',
          value: 1
        },
        {
          text: 'Grupo A - Verde',
          value: 2
        },
        {
          text: 'Grupo A - Azul',
          value: 3
        }
      ],
      tiposInstalacao: [
        {
          text: 'Comercial',
          value: 1
        },
        {
          text: 'Industrial',
          value: 2
        },
        {
          text: 'Residencial',
          value: 3
        },
        {
          text: 'Rural',
          value: 4
        },
        {
          text: 'Outros',
          value: 5
        }
      ],
      tiposEstrutura: []
    }
  },
  methods: {
    moment,
    async verificaHeaders () {
      let header = []
      this.tabela.headers.filter(item => {
        if (item && item.text !== 'Ações' && item.text !== 'Imagem') {
          header.push(item)
        }
      })
      this.tabela.headers = header
      this.tamanhoLista = this.tabela.headers.length > 10 ? 9999 : 600

      if (this.landscape && this.landscape !== 'null') this.tamanhoLista = 600
    },
    async getDados () {
      this.carregando = true
      await Api.get(this.tabela.url)
        .then(res => {
          if (res.data) {
            this.dados = []
            if (res.data.length > 0) {
              this.dados = res.data
            }
          }
        })
        .catch(err => {
          this.carregando = false
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao buscar os dados do PDF!',
            color: 'error'
          })
          console.log(err)
        })
    },
    retornaCategoriaProduto (catId) {
      let categoria = this.tabela.categorias.find(cat => cat.cat_id === catId)

      if (!categoria) {
        categoria = {
          cat_id: 0,
          text: 'Categoria removida!',
          value: null,
          color: 'red accent-4'
        }
      }

      return categoria.text
    },
    formataCEP (cep) {
      if (!cep) return ''
      cep = cep.toString()
      cep = `${cep.substr(0, 5)}-${cep.substr(5)}`
      return cep
    },
    retornaValor (valor) {
      if (!valor) return 'R$ 0,00'
      return this.$root.Formatter.floatToMoney(valor)
    },
    retornaEtapa (oportunidade) {
      if (!oportunidade.etapas || !oportunidade.etapas.length) return null

      let etapaAtual = null
      let funilAtual = 1

      if (oportunidade.opu_status === 3) funilAtual = 2
      oportunidade.etapas.map(etapa => {
        if (etapa.fk_fun_id_funil === funilAtual) etapaAtual = etapa
      })
      return etapaAtual
    },
    retornaDecimal (valor) {
      if (!valor) return '0,00'
      return valor.toString().replace('.', ',')
    },
    retornaTipoInstalacao (tipo) {
      if (!tipo) return null
      let tipoSelecionado = this.tiposInstalacao[tipo - 1]
      return tipoSelecionado ? tipoSelecionado.text : null
    },
    retornaTipoEstrutura (tipoSel) {
      if (!tipoSel) return null
      let tipoSelecionado = this.tiposEstrutura.find(tipo => tipo.tie_id === tipoSel)
      return tipoSelecionado ? tipoSelecionado.tie_nome : null
    },
    async formatarItens () {
      this.dados.map(item => {
        if (item.cli_tipo === 1) {
          item.cli_doc = item.cli_cpf
          item.cli_tipo = 'Pessoa Física'
        }
        if (item.cli_tipo === 2) {
          item.cli_doc = item.cli_cnpj
          item.cli_tipo = 'Pessoa Jurídica'
        }
        if (item.integrador === null) {
          item.int_dis_nome = 'Não possui'
        } else {
          item.int_dis_nome = item.integrador.int_nome
        }
        if (item.pro_categoria) {
          item.pro_categoria = this.retornaCategoriaProduto(item.pro_categoria)
          if (item.pro_preco_custo == null) {
            item.pro_preco_custo = 0
          }
          if (item.pro_preco_venda == null) {
            item.pro_preco_venda = 0
          }
        }
        if (item.pro_preco_custo != null) {
          item.pro_preco_custo = this.$root.Formatter.floatToMoney(item.pro_preco_custo)
        }
        if (item.pro_preco_venda != null) {
          item.pro_preco_venda = this.$root.Formatter.floatToMoney(item.pro_preco_venda)
        }
        if (item.marca) {
          item.marca = item.marca.mar_nome
        }
        if (item.modelo) {
          item.modelo = item.modelo.mod_nome
        }
        if (item.opu_cep) {
          item.opu_cep = this.formataCEP(item.opu_cep)
        }
        if (item.opu_criado_em) {
          item.opu_criado_em = this.$root.Formatter.formatDate(item.opu_criado_em, 'DD/MM/YYYY')
          item.pos_total = this.retornaValor(item.pos_total)
        }
        if (item.etapas) {
          item.etapa = this.retornaEtapa(item)
        }
        if (item.opu_status) {
          item.opu_status = this.statusGerais[item.opu_status - 1].text
        }
        if (item.orc_cep) {
          item.orc_cep = this.formataCEP(item.orc_cep)
        }
        if (item.orc_criado_em) {
          item.orc_criado_em = this.$root.Formatter.formatDate(item.orc_criado_em, 'DD/MM/YYYY')
          item.orc_total = this.retornaValor(item.orc_total)
        }
        if (item.orc_consumo_mensal) {
          item.orc_consumo_mensal = this.retornaDecimal(item.orc_consumo_mensal) + ' kWh'
        }
        if (item.orc_potencia) {
          item.orc_potencia = this.retornaDecimal(item.orc_potencia) + ' kWp'
        }
        if (item.orc_potencia_modulo) {
          item.orc_potencia_modulo = this.retornaDecimal(item.orc_potencia_modulo) + ' W'
        }
        if (item.orc_tipo_instalacao) {
          item.orc_tipo_instalacao = this.tiposInstalacao[item.orc_tipo_instalacao - 1].text
        }
        if (item.orc_entrada_padrao) {
          item.orc_entrada_padrao = this.padroes[item.orc_entrada_padrao - 1].text
        }
        if (item.orc_modalidade_tarifaria) {
          item.orc_modalidade_tarifaria = this.modalidades[item.orc_modalidade_tarifaria - 1].text
        }
        if (item.orc_tipo_estrutura) {
          item.orc_tipo_estrutura = this.retornaTipoEstrutura(item.orc_tipo_estrutura)
        }
        if (item.oportunidade) {
          if (item.oportunidade.opu_cep) {
            item.opu_cep = this.formataCEP(item.oportunidade.opu_cep)
          }
          if (item.oportunidade.etapas) {
            item.etapa = this.retornaEtapa(item.oportunidade).fet_nome
          }
          if (item.oportunidade.opu_tipo_instalacao) {
            item.opu_tipo_instalacao = this.tiposInstalacao[item.oportunidade.opu_tipo_instalacao - 1].text
          }
          if (item.oportunidade.opu_tipo_estrutura) {
            item.opu_tipo_estrutura = this.retornaTipoEstrutura(item.oportunidade.opu_tipo_estrutura)
          }
          item.opu_uf = item.oportunidade.opu_uf
          item.opu_cidade = item.oportunidade.opu_cidade
        }
        if (item.pos_criado_em) {
          item.pos_criado_em = this.$root.Formatter.formatDate(item.pos_criado_em, 'DD/MM/YYYY')
          item.pos_total = this.retornaValor(item.pos_total)
        }
        if (item.pos_potencia) {
          item.pos_potencia = this.retornaDecimal(item.pos_potencia) + ' kWp'
        }
        if (item.pos_potencia_modulo) {
          item.pos_potencia_modulo = this.retornaDecimal(item.pos_potencia_modulo) + ' W'
        }
        if (item.pos_status) {
          item.pos_status = this.statusGerais[item.pos_status - 1].text
        }
      })
      this.carregando = false
    },
    print () {
      setTimeout(() => {
        window.print()
      }, 500)
    }
  },
  async created () {
    this.$vuetify.theme.dark = false
    this.theme = this.$vuetify.theme.dark

    let filters = this.$route.query
    console.log(filters, 'filters')
    if (filters.tabelaPrint) {
      this.tabela = JSON.parse(filters.tabelaPrint)
      this.tabela.headers = JSON.parse(this.tabela.headers)
      if (this.tabela.categorias) this.tabela.categorias = JSON.parse(sessionStorage.getItem('categorias'))
      if (this.tabela.uuid) this.dados = JSON.parse(sessionStorage.getItem(this.tabela.uuid))
      if (this.tabela.tiposEstrutura) this.tiposEstrutura = JSON.parse(sessionStorage.getItem('tiposEstrutura'))
    }
    if (filters.tabelaExtraPrint) {
      this.tabelaExtra = JSON.parse(filters.tabelaExtraPrint)
      this.tabelaExtra.headers = JSON.parse(this.tabelaExtra.headers)
      if (this.tabelaExtra.uuid) this.tabelaExtra.dados = JSON.parse(sessionStorage.getItem(this.tabelaExtra.uuid))
    }
    if (filters.localPrint) this.titulo = filters.localPrint
    if (filters.subtituloPrint) this.subtitulo = filters.subtituloPrint
    if (filters.landScapePrint) this.landscape = filters.landScapePrint
    if (filters.isRelatorioPrint) this.isRelatorio = filters.isRelatorioPrint
    if (filters.url) this.url = filters.url

    await this.verificaHeaders()
    if (this.tabela.url && this.dados.length === 0) {
      await this.getDados()
      await this.formatarItens()
    }
    this.print()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.border_table {
  border: 1px $graywhite solid;
  &_right {
    border-right: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
  &_bottom {
    border-bottom: 1px $graywhite solid;
    padding-bottom: 10px!important;
    padding-top: 10px!important;
  }
}
.text-small {
  font-size: 12px;
}
.print {
  width: 100%!important;
}
</style>



// WEBPACK FOOTER //
// src/components/ExportPdf.vue